import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import HelpItem from "../Components/HelpItem";
import HelpSearchBox from "../Components/HelpSearchBox";
import Pagination from "../Components/Pagination";
import ContextComponent from "../Context";
import Product from "../Images/product.png";
import Statics from "../Statics";
import Config from "../config.json";
import { t } from "../lib/utils";
import HelpSidebar from "./HelpSidebar";

const title = "راهنمای آموزش";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | آموزش",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

export const HelpHeaderBanner = () => (
  <HeaderBanner
    body={t("helpPageDescription")}
    title={title}
    image={Product}
    header_color="#cecbfa"
  />
);

const HelpIndex = () => {
  const context = useContext(ContextComponent);
  const [helps, set_helps] = useState({});
  const [categories, set_categories] = useState([]);
  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);
  const [category_loading_state, set_category_loading_state] = useState(
    Statics.NOT_LOADED,
  );

  const gethelpCategories = () => {
    set_category_loading_state(Statics.LOADING);
    context.ApiDriver.getHelpCategories(
      {
        scope: "mylib",
      },
      (data, meta) => {
        set_categories(data.data);

        set_category_loading_state(Statics.LOADED);
      },
      error => {
        console.log(error);
        set_category_loading_state(Statics.CAUSED_ERROR);
      },
    );
  };
  const [page, set_page] = useState(1);
  const [page_size] = useState(7);
  const [totalCount, set_totalCount] = useState(null);
  const gethelpPost = (p = 1) => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.getHelp(
      {
        current_page: p,
        page_size,
        query: context.query_parameters["search_term"],
        category_id: 23,
      },
      (data, meta) => {
        console.log(data);

        set_helps(data.data);
        set_totalCount(data.meta.total);
        set_page(data.meta.current_page);
        set_loading_state(Statics.LOADED);
      },
      error => {
        console.log(error);
        set_loading_state(Statics.CAUSED_ERROR);
      },
    );
  };
  useEffect(gethelpPost, [context.query_parameters["search_term"]]);

  if (category_loading_state === Statics.NOT_LOADED) {
    gethelpCategories();
  }
  if (loading_state === Statics.NOT_LOADED) {
    gethelpPost();
  }
  return (
    <DocumentMeta {...page_meta}>
      <HelpHeaderBanner />
      <Row style={{ padding: "30px 30px", background: "#eee" }}>
        <Col md={3} style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <HelpSearchBox />
          <HelpSidebar sidebar_title="فهرست" data={categories} />
        </Col>
        <Col md={9} style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {loading_state === Statics.NOT_LOADED ? "بارگذاری نشده" : ""}
          {loading_state === Statics.CAUSED_ERROR ? "ارتباط با سرور با مشکل مواجه شد !" : ""}
          {loading_state === Statics.LOADING ? (
            <div className="d-flex justify-content-center py-2">
              <Spinner
                animation="border"
                variant="warning"
                style={{ width: "5rem", height: "5rem" }}
              />
            </div>
          ) : (
            ""
          )}
          {loading_state === Statics.LOADED && totalCount > 0 ? (
            helps.map(help => (
              <HelpItem data={help} linkToPost={"/help-my-lib/" + help.id} />
            ))
          ) : loading_state === Statics.LOADED && totalCount === 0 ? (
            <Row>موردی یافت نشد</Row>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row
        className="justify-content-center"
        style={{ padding: "30px 30px", background: "#eee" }}>
        {totalCount > 7 ? (
          <Pagination
            onPageChange={gethelpPost}
            currentPage={page}
            totalCount={totalCount}
            pageSize={page_size}
          />
        ) : (
          ""
        )}
      </Row>
    </DocumentMeta>
  );
};

export default HelpIndex;
